var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKeplrIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Keplr_icon_ver.1.3_2 1",
    clipPath: "url(#clip0_1543_144821)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1543_144821",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 49,
    height: 49
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clip0_425_5107"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M48.5 0.0976562H0.5V48.0977H48.5V0.0976562Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1543_144821)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M37.5909 0.0976562H11.4091C5.38417 0.0976562 0.5 4.98183 0.5 11.0067V37.1885C0.5 43.2135 5.38417 48.0977 11.4091 48.0977H37.5909C43.6159 48.0977 48.5 43.2135 48.5 37.1885V11.0067C48.5 4.98183 43.6159 0.0976562 37.5909 0.0976562Z",
    fill: "url(#paint0_linear_1543_144821)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M37.5909 0.0976562H11.4091C5.38417 0.0976562 0.5 4.98183 0.5 11.0067V37.1885C0.5 43.2135 5.38417 48.0977 11.4091 48.0977H37.5909C43.6159 48.0977 48.5 43.2135 48.5 37.1885V11.0067C48.5 4.98183 43.6159 0.0976562 37.5909 0.0976562Z",
    fill: "url(#paint1_radial_1543_144821)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M37.5909 0.0976562H11.4091C5.38417 0.0976562 0.5 4.98183 0.5 11.0067V37.1885C0.5 43.2135 5.38417 48.0977 11.4091 48.0977H37.5909C43.6159 48.0977 48.5 43.2135 48.5 37.1885V11.0067C48.5 4.98183 43.6159 0.0976562 37.5909 0.0976562Z",
    fill: "url(#paint2_radial_1543_144821)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M37.5909 0.0976562H11.4091C5.38417 0.0976562 0.5 4.98183 0.5 11.0067V37.1885C0.5 43.2135 5.38417 48.0977 11.4091 48.0977H37.5909C43.6159 48.0977 48.5 43.2135 48.5 37.1885V11.0067C48.5 4.98183 43.6159 0.0976562 37.5909 0.0976562Z",
    fill: "url(#paint3_radial_1543_144821)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M20.2172 36.9671V25.8331L31.0354 36.9671H37.0541V36.6774L24.6101 23.9966L36.0964 11.9663V11.8242H30.0387L20.2172 22.4552V11.8242H15.3398V36.9671H20.2172Z",
    fill: "white"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1543_144821",
    x1: 24.5,
    y1: 0.0976562,
    x2: 24.5,
    y2: 48.0977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FD1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BB8FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1543_144821",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.79283 46.2789) rotate(-45.1556) scale(76.9768 78.1285)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#232DE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#232DE3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1543_144821",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.9147 47.8236) rotate(-138.45) scale(48.1299 73.3847)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B4DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B4DFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1543_144821",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.1001 0.453654) rotate(90) scale(37.844 91.8198)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24D5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BB8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1543_144821"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.5 0.0976562)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeplrIcon);
export default __webpack_public_path__ + "static/media/keplr-icon.e6fe472fa69aed0f979e099a51e01ae2.svg";
export { ForwardRef as ReactComponent };